export class CreateBankModel {
  public codigoBanco = ''
  public nome = ''
  public statusBanco: string | 'S' | 'N' = 'N'
}

export class EditBankModel {
  public id = 0
  public codigoBanco = ''
  public nome = ''
  public statusBanco: string | 'S' | 'N' = 'N'
}

export class DeleteBankModel {
  public id = 0
  public nome = ''
}

export class SearchBankModel {
  public nome = ''
}

export class CreateBankResponse {
  public response: any
}
export class EditBankResponse {
  public response: any
}
export class DeleteBankResponse {
  public response: any
}
export class PagedBankResponse {
  public response: any
}
